import * as React from "react";
import { MainSection } from "../../../components/atoms/MainSection";
import { StudentFreePlanNotice } from "../../../components/features/StudentFreePlanNotice";
import { StudyScheduleForm } from "../../../components/molecules/StudyScheduleForm";
import { hasLearningManagementService } from "../../../domains/PaidService";
import { OutletContextProps } from "../../../helpers/RouterHelper";
import enhanceStudentsPage from "../../../hocs/enhanceStudentsPage";
import { useFetchBookshelfEntries } from "../../../hooks/http/useBookshelfEntries";
import { useQueryError } from "../../../hooks/http/useQueryError";
import { useFlashMessage } from "../../../hooks/useFlashMessage";
import StudentInterface from "../../../interfaces/StudentInterface";
import StudentStudyScheduleIndex from "./StudentStudyScheduleIndex/index";
import { useStudentStudySchedules } from "./useStudentStudySchedules";
import { useFetchStudySchedules } from "./useStudyScheduleApi";

type Props = OutletContextProps & {
  student: StudentInterface;
};

const Component = (props: Props): React.ReactElement<any> => {
  React.useEffect(() => {
    props.setActiveMenu("study_schedules");
  }, []);
  const bookshelfEntriesState = useFetchBookshelfEntries(props.student.id, {
    type: "all",
  });

  useQueryError(bookshelfEntriesState.error);

  const { startDate, endDate } = useStudentStudySchedules();
  const studySchedulesState = useFetchStudySchedules({
    from: startDate,
    to: endDate,
    studentId: props.student.id,
  });

  useQueryError(studySchedulesState.error);

  const { showSuccessMessage, showErrorMessage } = useFlashMessage();

  const handleStudyScheduleMutateSuccess = React.useCallback(
    (message: string) => {
      showSuccessMessage(message);
      studySchedulesState.refetch();
    },
    [studySchedulesState],
  );

  if (!hasLearningManagementService(props.student)) {
    return (
      <div className="mt-10 whitespace-nowrap break-keep text-center align-middle text-gray-800">
        <StudentFreePlanNotice
          lastName={props.student.lastName}
          firstName={props.student.firstName}
          sectionId={props.student.section.id}
          description="にすると全ての学習計画の閲覧ができます"
          iconClassName="text-gray-800"
        />
      </div>
    );
  }

  return (
    <React.Fragment>
      <MainSection>
        <StudyScheduleForm
          student={props.student}
          loadingBookshelfEntries={bookshelfEntriesState.isLoading}
          bookshelfEntries={bookshelfEntriesState.data || []}
          onMutateSuccess={handleStudyScheduleMutateSuccess}
          onMutateError={showErrorMessage}
        />
      </MainSection>
      <StudentStudyScheduleIndex
        student={props.student}
        data={studySchedulesState.data}
        isLoading={studySchedulesState.isLoading}
      />
    </React.Fragment>
  );
};

const pageInfo = {
  title: "学習計画",
};

const StudentsStudySchedulesPage = enhanceStudentsPage(Component, pageInfo);

export default StudentsStudySchedulesPage;
